import { MutationTree } from "vuex";
import { LangState, types } from "./types";

export const mutations: MutationTree<LangState> = {
  [types.SET_LOCALE](state, { locale }) {
    state.locale = locale;
  },
};
